import { encodingForModel } from "js-tiktoken";

let tokenizer;
const initializeTokenizer = async () => {
  if (!tokenizer) {
    tokenizer = await encodingForModel("gpt-4");
  }
};

export const calculateTokenCount = async (text) => {
  try {
    await initializeTokenizer();
    return tokenizer.encode(text).length;
  } catch (_) {
    const tokens = text.match(/\S+|\n|[.,!?;]/g) || [];
    let tokenCount = tokens.length;
    tokenCount += tokens.filter((token) => /^[A-Z][a-z]+$/.test(token)).length;
    tokenCount -= tokens.filter((token) => token.length <= 2).length * 0.5;
    return Math.round(tokenCount);
  }
};
